// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltipbar{font-size:14px;font-weight:400}.tooltipbar .alert{border-radius:0;margin-bottom:0;text-align:center}.tooltipbar .alert .alert-link{color:#007bff;font-size:14px;font-weight:400;margin-left:12px}.tooltipbar .alert .title .fa-circle-info,.tooltipbar .alert .title .fa-info-circle{margin-right:5px}.tooltipbar .alert .title .just-close{cursor:pointer}.tooltipbar .alert .message{background-color:#fff;border:1px solid #ffe8a0;margin-top:15px}", ""]);
// Exports
module.exports = exports;
